import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {isMobile} from 'react-device-detect';
import Config from '../../../../Config';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import MainTitleComponent from '../Headline/MainTitleComponent';
import {images, changeAccountImage} from '../images/images';
import {
  gAChangePPUserHasNotCellularPlan,
  gAChangePPTypeError,
  gAChangePPModemError,
  gAChangePPSamePlanError,
  gAChangePPFuturePPError,
  gAChangePPFailedPartLimited,
} from '../reports/gaReports';
import {
  saveToHistory,
} from './../changePricePlanSlice'
import {connect} from "react-redux";

const ErrorComponent = (props) => {
  if (props.props.errorReason == 'server_error') return null;
  const {titleBold = '', withImage = false, description = '', callBtn = false, callBtnText} = props.props.errorData;
  const {buttonFunction} = props;

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
    switch (props.props.errorReason) {
      case 'start_error':
        gAChangePPUserHasNotCellularPlan();

        break;
      case 'account_type':
        gAChangePPTypeError();

        break;
      case 'modem':
        break;
      case 'np_status':
        gAChangePPModemError();
        break;
      case 'futurePPInd':
        gAChangePPFuturePPError();
        break;
      case 'the_same_plan':
        gAChangePPSamePlanError();
        break;
      case 'error_failed_part_of':
        gAChangePPFailedPartLimited();
        break;
      default:
      // code block
    }

    if (!props.likeHistoryStep && validationError()) {
      props.saveToHistory();
    } else {
      props.saveToHistory('msg');
    }
  }, []);

  function validationError() {
    if (
      props.props.errorReason == 'start_error' ||
      props.props.errorReason == 'account_type' ||
      props.props.errorReason == 'modem' ||
      props.props.errorReason == 'np_status' ||
      props.props.errorReason == 'futurePPInd'
    ) {
      return true;
    } else return false;
  }

  return (
    <div className='failure-container'>
      <MainTitleComponent title={'שינוי חבילת סלולר'} />
      {titleBold && (
        <div className='d-flex justify-content-center'>
          <div className='bold main-text d-block'>
            <p dangerouslySetInnerHTML={{__html: titleBold}} />
          </div>
        </div>
      )}
      {description.trim() != '' && (
        <div className='d-flex justify-content-center text-center'>
          <div className='description'>
            <p dangerouslySetInnerHTML={{__html: description}} />
          </div>
        </div>
      )}

      {props.props.errorReason == 'limitedOnOTP' && (
        <div className='change-account-button'>
          <BtnWhiteBlackBorderBigSize svgImage={changeAccountImage} text='שדרוג חבילות למנויים נוספים' onclick={props.redirectToLogin} />
        </div>
      )}
      {callBtn && (
        <div className='failure-call-button-container'>
          <p className='message-text text-center'>
            <span dangerouslySetInnerHTML={{__html: callBtnText}} />
            {isMobile ? (
              <span className={`asBtn text-center sub-text d-block`}>
                <a href={`tel:${window.Config.technicalSupportPhone}`}>
                  לשיחה עם נציג
                  <Image src={images.call} alt='call' className='ml-2' />
                </a>
              </span>
            ) : (
              <span className='d-block pink-text'>אנחנו זמינים במספר {Config.technicalSupportPhone}</span>
            )}
          </p>
        </div>
      )}

      {withImage && (
        <div className='justify-content-center d-flex'>
          <div className='img-wrapper'>
            <Image src={images.error} alt='image' />
          </div>
        </div>
      )}
      <div className='justify-content-center d-flex'>
        <div className='btn-wrapper'>
          <BtnSubmit formid='failure-screen' onclick={() => buttonFunction()} text='הבנתי'></BtnSubmit>
        </div>
      </div>
    </div>
  );
};


const mapStateToProps = (state) => {
  return {
    data: state.changePricePlan,
  };
};

const mapDispatchToProps = {
  saveToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorComponent);
